import { interval as observableInterval, Observable, Subscription } from 'rxjs';

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
  ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

import { LevelViewModel } from '@models/level-two.class';
import { AppState, USER_ROLES } from 'src/app';
import { SharedSolaceStreamService } from 'src/solace';

@Component({
  selector: 'hb-posturas',
  templateUrl: './posturas.component.html',
  styleUrls: ['./posturas.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PosturasComponent implements OnChanges, OnInit {
  @Input() posturasList: LevelViewModel[];
  @Input() hasLevel: boolean;
  @Input() hasIssue: boolean;
  @Input() currentIssue: string;
  @Output() emitPrice: EventEmitter<any> = new EventEmitter();

  public opened = false;
  public single: LevelViewModel;
  public NO_LEVEL2 = false;

  private intervalObservable$: Observable<any> = observableInterval(1 * 1000);

  private resetSubscription: Subscription;

  private userRoleSubscription: Subscription;

  constructor(
    private sharedSolaceStreamService: SharedSolaceStreamService,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.listenForUserRole();

    this.resetSubscription = this.store
      .select('operation')
      .pipe(
        map((value: any) => value.toJS()),
        distinctUntilChanged(),
      )
      .subscribe((value: any) => {
        if (value.hardReset) {
          this.posturasList = [];
          this.hasIssue = false;
          this.currentIssue = '';
          this.opened = false;
        }
      });
  }

  toggleDeep() {
    this.opened = !this.opened;
  }

  setPrice($event: any) {
    this.emitPrice.emit($event);
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    const { posturasList, currentIssue, hasLevel } = changes;

    if (posturasList && posturasList.currentValue) {
      if (posturasList.currentValue.length) {
        this.single = posturasList.currentValue[0];
        this.posturasList = posturasList.currentValue.slice(1, 5);
      }
    }

    if (hasLevel && hasLevel.currentValue) {
      this.hasLevel = hasLevel.currentValue;
    }

    if (currentIssue && currentIssue.currentValue) {
      this.opened = currentIssue.currentValue;
      this.hasIssue = currentIssue.currentValue;
    }
  }

  listenForUserRole() {
    this.userRoleSubscription = this.store
      .select('userRole')
      .pipe(filter((value: any) => value !== undefined))
      .subscribe((value: any) => {
        this.NO_LEVEL2 = value === USER_ROLES.READONLY;
      });
  }
}
